import angular from 'angular';

angular
  .module('commonServices')
  .filter('dynNumber', [
    '$filter',
    function($filter) {
      return function(value, min, max) {
        if (typeof value === 'string') value = parseFloat(value);
        if (value == null || isNaN(value)) return '';
        //return value;
        var fraction = value.getFractionSize();
        if (typeof min !== 'undefined' && min != null) fraction = fraction > min ? fraction : min;
        if (typeof max !== 'undefined' && max != null) fraction = fraction > max ? max : fraction;
        return $filter('number')(value, fraction);
      };
    },
  ])
  .filter('dynCurrency', ['$filter', 'dataCache', dynCurrency]);
function dynCurrency($filter, dataCache) {
  return function(value, min, max) {
    if (typeof value === 'string') value = parseFloat(value);
    if (value == null || isNaN(value)) return '';

    var fraction = value.getFractionSize();
    if (typeof min === 'undefined' || min === null) min = 2; //If no minimum passed, set minimum to 2
    if (typeof max === 'undefined' || max === null) max = 2; //If no maximum passed, set maximum to 2

    fraction = fraction > min ? fraction : min;
    fraction = fraction > max ? max : fraction;

    var amount = $filter('number')(value, fraction);
    return '€ ' + amount;
  };
}
